import { render, staticRenderFns } from "./gfApp.vue?vue&type=template&id=37635e8a&scoped=true"
import script from "./gfApp.vue?vue&type=script&lang=js"
export * from "./gfApp.vue?vue&type=script&lang=js"
import style0 from "./gfApp.vue?vue&type=style&index=0&id=37635e8a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37635e8a",
  null
  
)

export default component.exports